import Head from 'next/head'
import Script from 'next/script'

export default function AppMeta() {
  return (
    <>
      <Head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />

        <link rel="shortcut icon" href="/favicon.ico" />

        {/* Inform the browser that this page only supports a dark color scheme. */}
        <meta name="color-scheme" content="dark" />

        <meta name="theme-color" content="#000000" />

        <link rel="apple-touch-icon" href="/logo152.png" />
        <link rel="manifest" href="/manifest.json" />

        <title>Section Console</title>
        <meta
          name="description"
          content="Section&#39;s Edge Compute Platform gives developers code-level control over edge configuration and deployment for application performance, security, and scalability."
        />
      </Head>
      <Script src="https://js.chargify.com/latest/chargify.js" async={false} />
    </>
  )
}
